export default __webpack_public_path__ + "static/media/deposit.17fc51d5.svg";